/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
import { AutoDeletePreviewRequestDTOToJSON, AutoDeletePreviewResponseDTOFromJSON, CommonSavedFilterCreateUpdateDTOToJSON, CommonSavedFilterResponseDTOFromJSON, } from '../models/index';
/**
 *
 */
export class CommonSavedFilterControllerApi extends runtime.BaseAPI {
    /**
     */
    async createCommonSavedFilterRaw(requestParameters, initOverrides) {
        if (requestParameters['commonSavedFilterCreateUpdateDTO'] == null) {
            throw new runtime.RequiredError('commonSavedFilterCreateUpdateDTO', 'Required parameter "commonSavedFilterCreateUpdateDTO" was null or undefined when calling createCommonSavedFilter().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/common-saved-filters`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CommonSavedFilterCreateUpdateDTOToJSON(requestParameters['commonSavedFilterCreateUpdateDTO']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => CommonSavedFilterResponseDTOFromJSON(jsonValue));
    }
    /**
     */
    async createCommonSavedFilter(requestParameters, initOverrides) {
        const response = await this.createCommonSavedFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async deleteCommonSavedFilterRaw(requestParameters, initOverrides) {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling deleteCommonSavedFilter().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/common-saved-filters/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async deleteCommonSavedFilter(requestParameters, initOverrides) {
        await this.deleteCommonSavedFilterRaw(requestParameters, initOverrides);
    }
    /**
     */
    async getAllCommonSavedFiltersRaw(requestParameters, initOverrides) {
        if (requestParameters['type'] == null) {
            throw new runtime.RequiredError('type', 'Required parameter "type" was null or undefined when calling getAllCommonSavedFilters().');
        }
        const queryParameters = {};
        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }
        if (requestParameters['targetMarket'] != null) {
            queryParameters['targetMarket'] = requestParameters['targetMarket'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/common-saved-filters`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CommonSavedFilterResponseDTOFromJSON));
    }
    /**
     */
    async getAllCommonSavedFilters(requestParameters, initOverrides) {
        const response = await this.getAllCommonSavedFiltersRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async previewAutoDeleteFilterRaw(requestParameters, initOverrides) {
        if (requestParameters['autoDeletePreviewRequestDTO'] == null) {
            throw new runtime.RequiredError('autoDeletePreviewRequestDTO', 'Required parameter "autoDeletePreviewRequestDTO" was null or undefined when calling previewAutoDeleteFilter().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/common-saved-filters/auto-delete-preview`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AutoDeletePreviewRequestDTOToJSON(requestParameters['autoDeletePreviewRequestDTO']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => AutoDeletePreviewResponseDTOFromJSON(jsonValue));
    }
    /**
     */
    async previewAutoDeleteFilter(requestParameters, initOverrides) {
        const response = await this.previewAutoDeleteFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async resumeAutoDeleteFilterRaw(requestParameters, initOverrides) {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling resumeAutoDeleteFilter().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/common-saved-filters/{id}/resume-auto-delete`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => CommonSavedFilterResponseDTOFromJSON(jsonValue));
    }
    /**
     */
    async resumeAutoDeleteFilter(requestParameters, initOverrides) {
        const response = await this.resumeAutoDeleteFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async updateCommonSavedFilterRaw(requestParameters, initOverrides) {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling updateCommonSavedFilter().');
        }
        if (requestParameters['commonSavedFilterCreateUpdateDTO'] == null) {
            throw new runtime.RequiredError('commonSavedFilterCreateUpdateDTO', 'Required parameter "commonSavedFilterCreateUpdateDTO" was null or undefined when calling updateCommonSavedFilter().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/common-saved-filters/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CommonSavedFilterCreateUpdateDTOToJSON(requestParameters['commonSavedFilterCreateUpdateDTO']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => CommonSavedFilterResponseDTOFromJSON(jsonValue));
    }
    /**
     */
    async updateCommonSavedFilter(requestParameters, initOverrides) {
        const response = await this.updateCommonSavedFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
/**
 * @export
 */
export const GetAllCommonSavedFiltersTypeEnum = {
    Keyword: 'KEYWORD',
    Store: 'STORE',
    Search: 'SEARCH',
    ProductStaging: 'PRODUCT_STAGING',
    Inventory: 'INVENTORY'
};
/**
 * @export
 */
export const GetAllCommonSavedFiltersTargetMarketEnum = {
    UnitedStates: 'UNITED_STATES',
    Brazil: 'BRAZIL',
    Canada: 'CANADA',
    Mexico: 'MEXICO',
    Australia: 'AUSTRALIA',
    Japan: 'JAPAN',
    India: 'INDIA',
    Singapore: 'SINGAPORE',
    Germany: 'GERMANY',
    Spain: 'SPAIN',
    France: 'FRANCE',
    Italy: 'ITALY',
    Netherlands: 'NETHERLANDS',
    Belgium: 'BELGIUM',
    Poland: 'POLAND',
    Sweden: 'SWEDEN',
    UnitedKingdom: 'UNITED_KINGDOM',
    Ireland: 'IRELAND',
    UnitedArabEmirates: 'UNITED_ARAB_EMIRATES',
    Egypt: 'EGYPT',
    SaudiArabia: 'SAUDI_ARABIA',
    All: 'ALL'
};
